function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from "react";
import { Step1Icon, Step2Icon, Step3Icon, Step4Icon, Step5Icon, ArrowIcon } from "./svg";
import { isReloy } from "../../../utils/isClient";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function RedeemSteps(_ref) {
  var config = _ref.config;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLargeScreen = _React$useState2[0],
    setIsLargeScreen = _React$useState2[1];
  React.useEffect(function () {
    var checkScreenSize = function checkScreenSize() {
      setIsLargeScreen(window.innerWidth >= 1400);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return function () {
      return window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  var isDarkMode = config === null || config === void 0 ? void 0 : config.darkMode;
  var iconColor = config === null || config === void 0 ? void 0 : config.primaryColor;
  var steps = [{
    id: 1,
    title: "Create Your Gift Basket",
    description: "Select your favourite products and add to the cart.",
    icon: /*#__PURE__*/_jsx(Step1Icon, {
      color: iconColor
    })
  }, {
    id: 2,
    title: isReloy(config) ? 'Redeem Your Points' : 'Redeem Now',
    description: "Confirm items in your cart and initiate the redemption process.",
    icon: /*#__PURE__*/_jsx(Step2Icon, {
      color: iconColor
    })
  }, {
    id: 3,
    title: "Enter Shipping Details",
    description: "Fill in your shipping address and contact details for delivery.",
    icon: /*#__PURE__*/_jsx(Step3Icon, {
      color: iconColor
    })
  }, {
    id: 4,
    title: "Confirm Redemption",
    description: "Enter the OTP to verify and complete the redemption process.",
    icon: /*#__PURE__*/_jsx(Step4Icon, {
      color: iconColor
    })
  }, {
    id: 5,
    title: "Finalise Payment",
    description: "Make the payment to confirm your order.",
    icon: /*#__PURE__*/_jsx(Step5Icon, {
      color: iconColor
    })
  }];
  return /*#__PURE__*/_jsx("div", {
    className: "pt-12",
    children: /*#__PURE__*/_jsxs("div", {
      className: "rounded-[28px] w-full mx-auto py-10 ".concat(isDarkMode ? "border" : "bg-[#f5f5f5]"),
      style: isDarkMode ? {
        borderColor: iconColor
      } : undefined,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center mb-14",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-2xl lg:text-3xl text-center").concat(isDarkMode ? "text-white" : ""),
          children: isReloy(config) ? "How to Redeem HT Points" : "How to Redeem Coins"
        }), /*#__PURE__*/_jsx("div", {
          className: "w-28 h-[2px] mt-4",
          style: {
            background: iconColor
          }
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "flex overflow-x-auto scrollbar-hide pb-4 space-x-8 px-6 md:px-10 lg:px-14 ".concat(isLargeScreen ? "justify-center" : ""),
        children: steps.map(function (step, index) {
          return /*#__PURE__*/_jsxs("div", {
            className: "relative flex-shrink-0 w-[180px] lg:w-[200px] pt-4",
            children: [index !== steps.length - 1 && /*#__PURE__*/_jsx("div", {
              className: "block absolute top-8 -right-2 z-10",
              children: /*#__PURE__*/_jsx(ArrowIcon, {
                color: iconColor
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "relative w-[100px] h-[100px] rounded-full flex items-center justify-center ".concat(isDarkMode ? "bg-[#2a1f10]" : "bg-[#EAE0D5]"),
              children: [/*#__PURE__*/_jsx("div", {
                className: "absolute -top-1 left-0 w-6 h-6 rounded-full text-white text-[14px] font-medium flex items-center justify-center",
                style: {
                  backgroundColor: iconColor
                },
                children: step.id
              }), step.icon]
            }), /*#__PURE__*/_jsx("h3", {
              className: "mt-6 text-[15px] font-semibold leading-6",
              style: {
                color: isDarkMode ? iconColor : "#000"
              },
              children: step.title
            }), /*#__PURE__*/_jsx("p", {
              className: "mt-2 text-[14px] leading-6 ".concat(isDarkMode ? "text-white" : ""),
              children: step.description
            })]
          }, step.id);
        })
      })]
    })
  });
}
export default RedeemSteps;